import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const TONE = { available: "text-emerald-400", unavailable: "text-[var(--ff-red)]", pending: "text-[var(--ff-text-dim)]" };
const LABEL = { available: "Available", unavailable: "Not available", pending: "No answer yet" };

// Everyone invited (all hosts + executive managers) and their answer.
export default function MeetingResponses({ meetingId }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/admin/meetings/${meetingId}/responses`)
      .then(({ data }) => setRows(data.responses))
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || "Could not load answers"));
  }, [meetingId]);

  if (err) return <div className="text-xs text-[var(--ff-red)]">{err}</div>;
  if (!rows) return <div className="text-xs text-[var(--ff-text-dim)] font-mono-ui">Loading answers…</div>;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2" data-testid={`meeting-responses-${meetingId}`}>
      {rows.map((r) => (
        <div key={r.user_id} className="bg-[var(--ff-bg)] border border-[var(--ff-border)] p-3 flex items-center gap-3" data-testid={`meeting-response-${meetingId}-${r.user_id}`}>
          {r.avatar ? <img src={r.avatar} alt="" className="w-8 h-8 rounded-full object-cover" /> : <div className="w-8 h-8 rounded-full bg-[var(--ff-surface)]" />}
          <div className="min-w-0">
            <div className="text-sm truncate">{r.name}</div>
            <div className="font-mono-ui text-[0.6rem] uppercase tracking-[0.12em]">
              <span className="text-[var(--ff-text-dim)]">{r.kind === "executive" ? "Exec" : "Host"} · </span>
              <span className={TONE[r.status]}>{LABEL[r.status]}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
